module.exports = __webpack_public_path__ + "img/aparat.94f40017.svg";